<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-data.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0">數據安全管控平台</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
					<h2 class="w-600 title text-center" style="font-size: 32px">數據安全管控平台</h2>
				<div style="margin-top: 48px; ">
					<p style="font-size: 18px">
						構建覆蓋數據全生命週期的安全防護體系，深度融合開發測試、運維管控、業務運營等核心場景，通過模組化集成實現全域聯防。
					</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
					<h2 class="w-600 title text-center" style="font-size: 32px">功能亮點</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">分層防護能力</div>
										<div class="t2">
											在數據採集端實施源頭鑒權與敏感信息識別，存儲層採用靜態加密與密鑰託管，使用側（如開發測試環境）部署動態脫敏，流通域（如API接口）強化水印追蹤與共享管控，外發環節執行權限分級審計，形成貫穿"採、存、用、傳、毀"的防護鏈條
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">多模型自由切換</div>
										<div class="t2">
											模型倉庫集成：預置Llama、Qwen、DeepSeek等主流開源模型，用戶可按需加載不同模型應對多樣化任務<br>
											離線全功能支援：所有模型推理、訓練、知識庫構建均可在斷網環境下完成，徹底擺脫雲端依賴
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">智能治理中樞</div>
										<div class="t2">
											依托分類分級引擎驅動差異化策略（如L4數據自動加密、L2數據脫敏共享），結合靜態脫敏（測試數據仿真）與動態脫敏（查詢實時掩碼）協同運作，通過行為分析實時監測異常操作（如越權訪問、批量導出），實現秒級告警與泄露溯源
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">統一運營界面</div>
										<div class="t2">
											整合審計日誌、風險事件、策略命中率等指標，通過全景可視化管理平台呈現數據安全態勢熱力圖，支持從策略配置→執行監控→違規處置→優化迭代的閉環治理
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/data1-1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">核心功能</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/data1-2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據分類分級</div>
										<div class="t2">
											基於行業或者企業分類分級標準，通過數據資產自動掃描和數據自動識別，對企業數據資產進行分類分級，根據數據安全級別及數據訪問用戶權限配置
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據靜態脫敏</div>
										<div class="t2">
											對敏感數據進行處理，使其不可讀、不可識別，保證數據安全性。同時保留原有數據唯一性、仿真性、關聯性等特徵，使其滿足數據庫的約束校驗和數據規則校驗
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據動態脫敏</div>
										<div class="t2">
											在生產環境中，通過代理的方式對數據庫實時訪問請求進行解析，按照一定的規則和算法對敏感數據的查詢和調用結果進行"實時"脫敏，保證數據安全
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據庫審計</div>
										<div class="t2">
											實時監控數據庫運行情況，為安全事件溯源和追責提供有力的依據，提供符合《網絡安全法》和《網絡安全等級保護2.0制度》等法律法規及政策要求的分析報表
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據安全共享</div>
										<div class="t2">
											基於數據資源目錄對共享數據進行訪問控制和操作權限管理，確保僅限經過授權的用戶訪問和操作數據，並對敏感數據進行脫敏、添加水印處理，讓共享過程更安全
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據防泄漏</div>
										<div class="t2">
											建立角色和權限系統，對用戶的數據訪問行為進行授權，根據用戶的權限結合訪問數據的安全級別配置安全訪問策略，並設置數據訪問的有效期
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
					<h2 class="w-600 title text-center" style="font-size: 32px">優勢價值</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">全生命週期安全護航</div>
										<div class="t2">
											幫助用戶對數據資產進行梳理、安全管控、態勢感知，通過定義數據訪問權限模型，實現數據使用事前審批、事中監控、事後審計，在挖掘數據價值的同時保證企業數據安全
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">一體化數據安全管控</div>
										<div class="t2">
											從數據採集安全、數據傳輸安全、數據共享安全、數據交換安全等多個維度對數據進行安全防護，實現數據安全統一管理、統一調度、統一服務、統一監控
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">多項數據安全技術加持</div>
										<div class="t2">
											融合機器學習、數據標識、大數據分析、關聯分析、去標識化處理、訪問控制等多項大數據技術和安全技術
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/data1-3.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>


		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
					<h2 class="w-600 title text-center" style="font-size: 32px">適用場景</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/data1-4.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">敏感數據處理</div>
										<div class="t2">
											銀行需對客戶身份證號、交易記錄等動態脫敏，確保開發測試環境不泄露真實數據；醫院在採集患者病歷信息時，需實時標記敏感字段（如診斷記錄）並自動加密存儲
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">合規審計</div>
										<div class="t2">
											金融交易日誌、醫療操作記錄需全鏈路加密審計，滿足GDPR或《個人信息保護法》要求，支持一鍵生成合規報告
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數據共享與交換</div>
										<div class="t2">
											政務平台共享人口、法人數據時，通過API水印追蹤和區塊鏈溯源，防止數據濫用。例如，跨部門調用戶籍信息需動態脫敏並留存操作日誌
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">歸檔與銷毀</div>
										<div class="t2">
											政府檔案長期保存需定期校驗數字指紋，銷毀涉密文件時需第三方審計並記錄物理銷毀過程
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">企業知識管理</div>
										<div class="t2">
											企業員工一鍵導入合同、技術文檔，由Embedding模型自動解析生成向量化知識網絡，支持自然語言檢索
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
